// extracted by mini-css-extract-plugin
export var avatar = "_mv-3";
export var avatarContainer = "_mv-2";
export var avatarSpacer = "_mv-5";
export var avatarSpacerContainer = "_mv-4";
export var avatarStackContainer = "_mv-1";
export var bubble = "_mv-0";
export var remainderBubble = "_mv-6";